import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { AppTitleService } from '../services/app-title.service/app-title.service';

@Injectable()
export class AppTitleStrategy extends TitleStrategy {
  private appName = 'Joii PMS';
  private title = inject(Title);
  private appTitle = inject(AppTitleService);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const currentRouteTitle = this.buildTitle(snapshot);
    const routeTitle = `${this.appName} ${currentRouteTitle ? '| ' + currentRouteTitle : ''}` || 'Joii PMS';

    this.appTitle.setPageTitle(routeTitle);
  }
}
